import { Omit, Partial } from '@40seas/entities/common';
import { Lead } from './lead.entity';
import { TenantlessBaseEntityFieldsArray } from '@40seas/models';

export class UpdateLeadDto extends Partial(Omit(Lead, TenantlessBaseEntityFieldsArray)) {}
